import { isArray } from 'lodash';
export var toArray = function (item) {
  if (!item) {
    return [];
  }
  return isArray(item) ? item : [item];
};